<template>
  <v-card>
    <v-card-title class="font-weight-bold black--text subtitle-1" style="background-color: #CFD8DC">
      <v-icon color="black" dark>mdi-exclamation</v-icon>
      <span>{{ item.order_id }}</span>
      <v-spacer></v-spacer>
      <v-btn icon @click="seeDetails(item)">
        <v-icon>mdi-dots-horizontal</v-icon>
      </v-btn>
      <v-btn icon @click="deleteOne(item.path)">
        <v-icon color="red">mdi-delete</v-icon>
      </v-btn>
    </v-card-title>
    <v-divider></v-divider>
    <v-card-text>
      <p>Date: {{ item.timestamp}}</p>
      <v-row class="mx-1">
        <v-chip color="primary" class="ma-1">{{item.function_name}}</v-chip>
        <v-chip color="red" dark class="ma-1">Error type: {{item.error_type}}</v-chip>
        <v-chip class="ma-1">Kitchen: {{ item.kitchen}}</v-chip>
        <v-chip class="ma-1">Concept: {{ item.concept}}</v-chip>
        <v-chip class="ma-1">Platform: {{ item.platform}}</v-chip>
      </v-row>
      <v-textarea
        :value="item.details"
        outlined
        label="Message"
        readonly
        auto-grow
        hide-details
        class="my-2"
        row-height="12"
      ></v-textarea>
    </v-card-text>
    <v-divider></v-divider>
    <v-card-actions>
      <v-row>
        <v-col :align="deviceSize ? 'start': 'center'">
          <v-btn
            rounded
            dark
            class="ma-1"
            small
            color="warning"
            @click="openContent(item.original_path)"
          >See original</v-btn>
          <v-btn
            rounded
            dark
            class="ma-1"
            small
            color="warning"
            @click="openContent(item.source_path)"
          >See source</v-btn>
        </v-col>
        <v-col :align="deviceSize ? 'end': 'center'">
          <v-btn
            rounded
            dark
            class="ma-1"
            small
            color="green"
            @click="retryOne(item.original_path, item.original_topic, item.path)"
          >Retry original</v-btn>
          <v-btn
            rounded
            dark
            class="ma-1"
            small
            color="green"
            @click="retryOne(item.source_path, item.source_topic, item.path)"
          >Retry source</v-btn>
        </v-col>
      </v-row>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  props: { item: { type: Object } },
  methods: {
    seeDetails(item) {
      this.$emit("seeDetails", item);
    },
    deleteOne(error_path) {
      this.$emit("deleteOne", error_path);
    },
    openContent(path) {
      this.$emit("openContent", path);
    },
    retryOne(path, topic, error_path) {
      this.$emit("retryOne", path, topic, error_path);
    },
  },
  computed: {
    deviceSize() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return false;
        case "sm":
          return false;
        case "md":
          return true;
        case "lg":
          return true;
        case "xl":
          return true;
      }
      return "100%";
    },
  },
};
</script>
